export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11617.bec7dd70.jpg";